import { useMemo } from "react";
import {
    EditIcon,
    LockIcon,
    CloseIcon,
    CheckIcon,
    ResendIcon,
    CancelIcon,
    DeleteIcon,
    DotsThreeIcon,
    InformationIcon,
    CopyIcon,
    DisabledResendIcon,
} from "../../assets/svg";

interface IProps {
    iconName?: "edit" | "view" | "close" | "delete" | "menu" | "check" | "cancel" | "lock" | "resend" | "copy";
    icon?: JSX.Element;
    size?: number;
    disabled?: boolean;
}

const CustomIcon: React.FC<IProps> = ({ iconName, size, icon, disabled }: IProps) => {
    const getIcon = (iconName: string) => {
        if (icon) {
            return icon;
        } else {
            switch (iconName) {
                case "edit":
                    return <EditIcon size={size || 22} color={iconColor("#4caf50")} />;
                case "view":
                    return <InformationIcon size={size || 22} color={iconColor("#1a73e8")} />;
                case "close":
                    return <CloseIcon size={size || 22} color={iconColor("#7b809a")} />;
                case "delete":
                    return <DeleteIcon size={size || 22} color={iconColor("#f44335")} />;
                case "menu":
                    return <DotsThreeIcon size={size || 22} color={iconColor("#000000")} />;
                case "check":
                    return <CheckIcon size={size || 22} color={iconColor("#1a73e8")}/>;
                case "cancel":
                    return <CancelIcon size={size || 22} color={iconColor("#f44335")} />;
                case "lock":
                    return <LockIcon size={size || 22} color={iconColor("#fb8c00")} />;
                case "resend":
                    if (disabled) {
                        return <DisabledResendIcon size={size || 22} />
                    }
                    return <ResendIcon size={size || 22} color={iconColor("#1a73e8")} />;
                case "copy":
                    return <CopyIcon size={size || 22} color={iconColor("#4caf50")} />;
                default:
                    return <></>;
            }
        }
    };

    const iconColor = (activeColor: string) => {
        return disabled ? "#bebebe" : activeColor;
    }

    const Icon = useMemo(() => getIcon(iconName), [iconName, icon, disabled]);

    return Icon;
};

export default CustomIcon;
